import { NewsletterStorage } from "@Engage.Data/services/storage/NewsletterStorage";
/**
 * NewsletterSessionQualifier
 * Checks whether the user arrived via a newsletter source (nxt_nl_source cookie).
 * Returns "true" if the cookie exists, "false" otherwise.
 * Server compares this against qualifier.Value ("true"/"false").
 */
export class NewsletterSessionQualifier {
    constructor() {
        this.key = "NewsletterSession";
    }
    process() {
        try {
            const newsletterSource = NewsletterStorage.getNewsletterSource();
            return newsletterSource != null ? "true" : "false";
        }
        catch (_a) {
            return "false";
        }
    }
}
